// src/common/helper/phone.helper.jsx
//
// Formatage des numéros de téléphone ivoiriens pour l'affichage.
// Règle : on n'affiche PAS l'indicatif +225 dans les tableaux — seulement le numéro
// national, groupé par 2 chiffres (ex : +2250710086845 → « 07 10 08 68 45 »).

/**
 * Formate un numéro pour l'affichage (sans indicatif).
 * @param {string} phone numéro brut (+225..., 00225..., 07..., avec ou sans espaces)
 * @param {string} fallback valeur retournée si le numéro est vide
 */
export const formatPhoneCI = (phone, fallback = '—') => {
  if (!phone) return fallback;

  let digits = String(phone).replace(/\D/g, '');
  if (!digits) return fallback;

  // Retrait de l'indicatif pays (+225 / 00225) quand il reste des chiffres derrière
  if (digits.startsWith('00225') && digits.length > 5) digits = digits.slice(5);
  else if (digits.startsWith('225') && digits.length > 3) digits = digits.slice(3);

  // Numéros ivoiriens : 10 chiffres → groupés par 2. Sinon on groupe quand même par 2
  // (jamais de troncature : on préfère un affichage lisible à une perte d'information).
  return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
};

const PhoneHelper = { formatPhoneCI };
export default PhoneHelper;
